import React from "react";
import { styled, css, ThemeProvider } from "styled-components";
import { genericInputFieldStyles, InputIconWrapper, InputWrapper, LabelWrapper, textInputThemes, ErrorMessage, } from "../../styles/sharedInputStyles";
import InputTooltip from "../InputTooltip";
import LeadIcons from "../LeadIcons";
import { Label } from "../Text";
import Colors from "../../styles/Colors";
import { Warning } from "../../icons/Warning";
const StyledSelect = styled.select `
  ${genericInputFieldStyles}

  /* IE 10 */
  &::-ms-expand {
    display: none;
  }
  ${({ theme }) => theme.state.hasValue &&
    css `
      border-color: ${theme.vars.placeholderNotShownBorderColor};
    `}
  ${({ theme }) => !theme.state.hasValue &&
    css `
      color: ${Colors.GRAY_DARK};
    `}
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 48 48'%3E%3Cpath d='M24 36c-.3 0-.5-.1-.7-.3l-22-22c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L24 33.6l21.3-21.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-22 22c-.2.2-.4.3-.7.3z'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: calc(100% - 15px) 50%;
`;
export const Select = ({ options, optionTitleFn, optionValueFn, label, leadingIcon, leadingIconSize = 30, required, value, disabled, tooltip, placeholder, tooltipPosition = "top-right", tooltipButtonTitle = "Toggle tooltip", state = "default", errorMessage, ...props }) => {
    const themeVars = textInputThemes[state];
    const themeStateVars = {
        hasValue: !!value,
        hasTrailingIcon: true,
        hasLeadingIcon: !!leadingIcon,
    };
    const iconColor = disabled
        ? themeVars.iconColor
        : themeStateVars.hasValue
            ? themeVars.placeholderNotShownIconColor
            : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                themeVars.iconColor;
    return (React.createElement(ThemeProvider, { theme: { vars: themeVars, state: themeStateVars } },
        React.createElement(LabelWrapper, null,
            React.createElement(Label, { label: label, required: required, size: "medium" },
                React.createElement(InputWrapper, null,
                    React.createElement(InputIconWrapper, null,
                        React.createElement(LeadIcons, { iconColor: iconColor, leadingIcon: leadingIcon, leadingIconSize: leadingIconSize },
                            React.createElement(StyledSelect, { value: value, disabled: disabled, required: required, ...props },
                                placeholder ? (React.createElement("option", { disabled: required, value: "" }, placeholder)) : null,
                                options.map((option) => {
                                    const optionValue = optionValueFn(option);
                                    const optionTitle = optionTitleFn(option);
                                    const optionItem = { ...option };
                                    return (React.createElement("option", { disabled: optionItem.disabled, key: optionItem.key || optionValue, value: optionValue }, optionTitle));
                                })))),
                    tooltip && (React.createElement(InputTooltip, { text: tooltip, position: tooltipPosition, buttonTitle: tooltipButtonTitle })))),
            errorMessage && state === "error" ? (React.createElement(ErrorMessage, null,
                React.createElement(Warning, null),
                errorMessage)) : null)));
};
export default Select;
//# sourceMappingURL=Select.js.map